import type {
  CreatorCategory,
  CreatorSex,
  CreatorStatus,
  CreatorType,
} from '@/types';

export type EditFormState = {
  email: string;
  notes: string;
  category: CreatorCategory;
  creator_type: CreatorType;
  sex: CreatorSex | '';
  status: CreatorStatus;
};

export const CATEGORIES_BY_TYPE: Record<CreatorType, CreatorCategory[]> = {
  empresa: [1, 2, 3],
  persona: [1, 2, 3, 4],
};

export const STATUSES: { value: CreatorStatus; label: string }[] = [
  { value: 'new', label: 'Nuevo' },
  { value: 'contacted', label: 'Contactado' },
  { value: 'negotiating', label: 'Negociando' },
  { value: 'closed_won', label: 'Cerrado' },
  { value: 'closed_lost', label: 'Perdido' },
  { value: 'promotion', label: 'Promo' },
];

function clampCategory(c: CreatorCategory, t: CreatorType): CreatorCategory {
  const max = t === 'empresa' ? 3 : 4;
  return c > max ? (max as CreatorCategory) : c;
}

export function changeType(form: EditFormState, t: CreatorType): EditFormState {
  return {
    ...form,
    creator_type: t,
    category: clampCategory(form.category, t),
    sex: t === 'empresa' ? '' : form.sex || 'H',
  };
}
